import React from "react";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";
import {Skeleton} from "antd";
import {SubCompanyPaymentContractsTable} from "components/_defaultComponents/SubCompanyPaymentContractsTable/SubCompanyPaymentContractsTable";
import {SubCompanyPaymentContractForm} from "./subCompanyPaymentContractForm/SubCompanyPaymentContractForm";
import {SubCompanyPoolCampaigns} from "./subCompanyPoolCampaings/subCompanyPoolCampaigns";

export const SubCompanyPaymentContractList = ({subCompanyId}) => {
    const stores = useStore();
    const userIsCustomer = !stores.meStore.checkRole("notVisibleForCompanyUser");

    const [
        subCompanyPaymentContractsLoading,
        subCompanyPaymentContracts,
        _,
        __,
        refetch
    ] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.companyStore.getSubCompanyPaymentContracts.bind(null, {
            subCompanyId
        }),
        dependencies: [subCompanyId]
    });

    const [subCompanyLoading, subCompany] = useFetch({
        fetchFn: stores.companyStore.getSubCompany.bind(null, {subCompanyId}),
        condition: !!subCompanyId,
        initialCall: !!subCompanyId
    });

    const subCompanyWorkType = subCompany?.data?.subCompanyWorkType;
    const isPool = subCompanyWorkType === "pool";
    const isDedicated = subCompanyWorkType === "dedicated";

    if (subCompanyPaymentContractsLoading) {
        return <Skeleton paragraph={{rows: 10, width: "100%"}} active={true}></Skeleton>;
    }

    return (
        <div style={{width: "100%"}}>
            <SubCompanyPaymentContractForm
                activeSubCompanyPaymentContract={subCompanyPaymentContracts?.activeContract || {}}
                subCompanyId={subCompanyId}
                onSuccess={async () => {
                    await refetch();
                }}
                isPool={isPool}
                isDedicated={isDedicated}
            />
            {!userIsCustomer && isPool ? (
                <>
                    <SubCompanyPoolCampaigns
                        subCompanyId={subCompanyId}
                        campaigns={subCompanyPaymentContracts.courierBonusCampaigns}
                        style={{marginTop: 20, marginBottom: 10}}
                    />
                </>
            ) : null}

            <SubCompanyPaymentContractsTable
                showTitle={true}
                subCompanyPaymentContracts={subCompanyPaymentContracts?.paymentContracts}
                size="small"
                refetch={async () => {
                    await refetch();
                }}
                style={{marginTop: 20, marginBottom: 10}}
            />
        </div>
    );
};
